module.exports = __webpack_public_path__ + "static/media/N_Promotion.b5ab9dc5.png";